module.exports = __webpack_public_path__ + "img/top-10-map-view.782fd16a.webp";